import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR, ESTILO_INPUT_GENERICO } from "../../../utils/const/estilos-const";
import "../../../style/style-cargando.css";
import { crearAlertaOpcionRespuestaPlaca, modificarAlertaOpcionRespuestaPlaca } from "../../../api/api-alerta-opcion-respuesta-placa";
import cargandoCard from "../../../components/cargando-card";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import { obtenerListaTipoOpcionesRespuesta } from "../../../api/configuracion";
import { obtenerTodasLasUnidades } from "../../../api/gestion-dts/gestion";
import { obtenerListaCorreos } from "../../../api/correo";

export default function AlertaOpcionRespuestaPlaca() {
  const { t } = useTranslation();
  const location = useLocation();
  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);
  const [formData, setFormData] = useState(null);
  const [titulo, setTitulo] = useState("");

  const [listaOpcionRespuesta, setListaOpcionRespuesta] = useState([]);
  const [opcionRespuestaSelected, setOpcionRespuestaSelected] = useState(null);

  const [listaVehiculos, setListaVehiculos] = useState([]);
  const [vehiculoSelected, setVehiculoSelected] = useState(null);

  const [listaCorreos, setListaCorreos] = useState([]);
  const [correosSelected, setCorreosSelected] = useState(null);

  useEffect(() => {
    // console.log("entro a Correos");
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      const data = location.state;
      // console.log("data");
      // console.log(data);
      if (data !== undefined && data !== null) {
        setFormData(data.params);
        setTitulo(data.titulo);
      }
      const optRespuesta = await obtenerListaTipoOpcionesRespuesta(true);
      // console.log('optRespuesta');
      // console.log(optRespuesta);
      setListaOpcionRespuesta(optRespuesta);
      if (data.params.idOpcionRespuesta !== null) {
        const opcionRespuesta = optRespuesta.find(e => e.value === data.params.idOpcionRespuesta);
        if (opcionRespuesta !== undefined) {
          setOpcionRespuestaSelected(opcionRespuesta);
        }
      }

      const unidades = await obtenerTodasLasUnidades();
      // console.log('unidades');
      // console.log(unidades);
      setListaVehiculos(unidades);
      if (data.params.valuePlaca !== null) {
        const vehiculo = unidades.find(e => e.value === data.params.valuePlaca);
        if (vehiculo !== undefined) {
          setVehiculoSelected(vehiculo);
        }
      }

      const listCorreos = await obtenerListaCorreos(true);
      setListaCorreos(listCorreos);

      if (data.params.listaCorreos !== null) {
        setCorreosSelected(JSON.parse(data.params.listaCorreos));
      }

      setCargandoPage(false);
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
      setCargandoPage(false);
    }
  }

  const handleInputChange = (event) => {
    // console.log('handleInputChange');
    const { name, value } = event.target;
    // console.log(name);
    // console.log(value);
    setFormData({ ...formData, [name]: value });
  };

  const handleCancelClick = () => {
    history.goBack();
  };

  const handleSaveClick = async () => {
    // console.log('handleSaveClick');
    // lógica para guardar los cambios
    // console.log('area');
    // console.log(area);
    let objEnviar = {};
    objEnviar.id = formData.id;
    objEnviar.idOpcionRespuesta = opcionRespuestaSelected.value;
    objEnviar.valuePlaca = vehiculoSelected.value;
    objEnviar.listaCorreos = correosSelected;
    objEnviar.nota = formData.nota;
    if (formData.id <= 0) {
      // console.log('crear correo');
      const creado = await crearAlertaOpcionRespuestaPlaca(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (creado === true) {
        alert(t('alert_se_creo_correctamente'));
        handleCancelClick();
      }
      if (creado === false) {
        alert(t('alert_no_se_pudo_crear'));
      }
    }
    if (formData.id !== 0) {
      // console.log('actualizar correo');
      const modificado = await modificarAlertaOpcionRespuestaPlaca(objEnviar);
      // console.log('modificado');
      // console.log(modificado);
      if (modificado === true) {
        alert(t('alert_se_modifico_correctamente'));
        handleCancelClick();
      }
      if (modificado === false) {
        alert(t('alert_no_se_pudo_modificar'));
      }
    }
  };

  const render = () => {
    // console.log('render correo');
    try {
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (cargandoPage === false && formData === null) {
        return (
          <div>
            <label> Sin data</label>
          </div>
        );
      }
      return (
        <div className="min-h-screen bg-gray-100 flex flex-col  py-12 sm:px-6 lg:px-8">
          <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <h2 className="text-center text-3xl font-extrabold text-gray-900">
              {titulo}
            </h2>
            <div className="mt-6 bg-white py-6 px-4 shadow-md rounded-lg sm:px-10">
              <div className="space-y-6">
                <div>
                  <label
                    htmlFor="opcion-respuesta"
                    className="block text-md font-medium text-gray-700"
                  >
                    {t('label_opcion_respuesta')}<span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1">
                    <Select
                      options={listaOpcionRespuesta}
                      isSearchable={true}
                      isClearable={true}
                      value={opcionRespuestaSelected}
                      onChange={(event) => {
                        setOpcionRespuestaSelected(event);
                      }}
                      placeholder={t('label_opcion_respuesta')}
                      className="w-full"
                      menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="vehiculo"
                    className="block text-md font-medium text-gray-700"
                  >
                    {t('label_vehiculo')}<span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1">
                    <Select
                      options={listaVehiculos}
                      isSearchable={true}
                      isClearable={true}
                      value={vehiculoSelected}
                      onChange={(event) => {
                        setVehiculoSelected(event);
                      }}
                      placeholder={t('label_vehiculo')}
                      className="w-full"
                      menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="lista-correos"
                    className="block text-md font-medium text-gray-700"
                  >
                    {t('label_lista_correos')}<span className="text-red-500">*</span>
                  </label>
                  <div className="mt-1">
                    <Select
                      options={listaCorreos}
                      isSearchable={true}
                      isClearable={true}
                      value={correosSelected}
                      onChange={(event) => {
                        setCorreosSelected(event);
                      }}
                      isMulti={true}
                      placeholder={t('label_lista_correos')}
                      className="w-full"
                      menuPortalTarget={document.body}  // Ensures dropdown is rendered outside
                      styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }} // Higher z-index
                    />
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="nota"
                    className="block text-md font-medium text-gray-700"
                  >
                    {t('label_nota')}
                  </label>
                  <div className="mt-1">
                    <textarea
                      id="nota"
                      name="nota"
                      type="text"
                      value={formData.nota}
                      onChange={handleInputChange}
                      autoComplete="given-name"
                      className={ESTILO_INPUT_GENERICO}
                      required
                      maxLength={500}
                    />
                  </div>
                </div>

                <div className="flex justify-end">
                  <div
                    style={{
                      justifyContent: 'space-between',
                      display: 'flex',
                      width: '100%'
                    }}
                  >
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_CANCELAR}
                      onClick={handleCancelClick}
                    >
                      {t('btn_cancelar')}
                    </button>
                    <button
                      type="button"
                      className={ESTILO_BOTON_GENERAL_ACEPTAR}
                      onClick={handleSaveClick}
                    >
                      {t('btn_aceptar')}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } catch (err) {
      console.log('Area render err');
      console.log(err);
      return (
        <div>
          <label>{JSON.stringify(err)}</label>
        </div>
      );
    }
  }

  return render();
}
